import { Link } from "wouter";
import CtaBanner from "@/components/powlo/home/CtaBanner";
import ScoreDemo from "@/components/powlo/home/ScoreDemo";
import PowloLayout from "@/components/powlo/PowloLayout";
import Seo from "@/components/Seo";

export default function Score() {
  return (
    <PowloLayout>
      <Seo
        title="Home Power Score"
        description="Like a credit score, for your property. Change the levers and watch your Home Power Score move, live."
        path="/score"
      />
      <section className="flex flex-col gap-4 px-5 pb-8 pt-14 sm:px-8 lg:px-20">
        <div className="text-sm font-bold tracking-widest text-indigo">HOME POWER SCORE</div>
        <h1 className="m-0 max-w-3xl font-display text-4xl font-bold leading-tight tracking-tight sm:text-6xl">
          Your Home Power Score
        </h1>
        <p className="m-0 max-w-2xl text-lg leading-relaxed text-muted">
          Like a credit score, for your property. It starts with what your roof and building can do, then
          moves with the system you fit, the tariff you are on, and how you use power.
        </p>
        <div className="text-sm text-mutedLight">
          Six pillars, fixed weights. Your roof and your building are property facts and never change. The
          other four move with what you fit, the tariff you&apos;re on and how you use power. Nothing here
          commits you to anything.{" "}
          <Link href="/methodology" className="font-semibold text-indigo">
            How we score, in full →
          </Link>
        </div>
        <div className="text-sm text-mutedLight">
          Scores shown here are at the <strong className="text-ink">Personalised</strong> stage — modelled
          estimates. Powlo verifies every design with a certified expert before installation.
        </div>
      </section>

      <section className="px-5 pb-24 sm:px-8 lg:px-20">
        <ScoreDemo />
      </section>

      <CtaBanner heading="Get my Energy Plan." body="Free, in about 60 seconds, with the full six-pillar breakdown behind it." />
    </PowloLayout>
  );
}
